<template>
    <!--<img alt="Vue logo" src="./assets/logo.png">-->
    <nav class="navbar navbar-expand-lg navbar-dark bg-primary mb-3">
        <div class="container-fluid">
            <router-link class="navbar-brand" to="/distributor/">テクノクラフ 発注ポータル</router-link>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent" v-if="$store.state.distributor.auth.is_signed_in">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <li class="nav-item">
                        <router-link class="nav-link active" to="/distributor/">ホーム</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link active" to="/distributor/school">発注</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link active" to="/distributor/order">発注履歴</router-link>
                    </li>
                    <li class="nav-item">
                        <a href="/guide/order-guide.pdf" class="nav-link active" target="_blank">
                            <i class="bi bi-question-circle"></i> ヘルプ
                        </a>
                    </li>

                    <li class="nav-item">
                        <a class="nav-link" href="#" @click="signOut()">ログアウト</a>
                    </li>
                </ul>
                <ul class="navbar-nav mb-2 mb-lg-0">
                    <li class="nav-item text-white">{{ $store.state.distributor.auth.distributor_user_name }} さん</li>
                </ul>
            </div>
        </div>
    </nav>

    <div class="container">
        <router-view/>
    </div>

    <screen-loader v-if="loading > 0"></screen-loader>

    <message-dialog ref="message_dialog" :title="dialog.title" :message="dialog.message" :icon="dialog.icon"></message-dialog>
</template>

<script>
import ScreenLoader from '@/shared/components/tool/ScreenLoader.vue'
import MessageDialog from '@/shared/components/tool/MessageDialog.vue'

export default {
    name: 'App',
    components: {
        ScreenLoader,
        MessageDialog
    },
    provide() {
        // 参考 emit/props vs provide/inject
        // https://cloudsmith.co.jp/blog/frontend/2020/12/1656030.html
        return {
            startScreenLoading: this.startScreenLoading,
            endScreenLoading: this.endScreenLoading,
            quitScreenLoading: this.quitScreenLoading,
            showMessage: this.showMessage,
            showErrorMessage: this.showErrorMessage,
        }
    },
    data() {
        return {
            loading: 0,
            dialog: {
                title: null,
                message: null,
                icon: null,
            }
        }
    },
    mounted() {
        window.addEventListener('show_message', (event) => {
            this.showMessage(event.detail.title, event.detail.message);
        });
        window.addEventListener('show_error_message', (event) => {
            this.showErrorMessage(event.detail.title, event.detail.message);
        });
    },
    methods: {
        signOut() {
            this.$store.commit('distributor/auth/signOut')
        },
        startScreenLoading() {
            this.loading++;
        },
        endScreenLoading() {
            this.loading--;
        },
        quitScreenLoading() {
            this.loading = 0;
        },
        showMessage(title, message) {
            this.dialog.title = title ?? '完了';
            this.dialog.message = message;
            this.dialog.icon = 'success';
            this.$refs.message_dialog.show();
        },
        showErrorMessage(title, message) {
            this.dialog.title = title ?? 'エラー';
            this.dialog.message = message;
            this.dialog.icon = 'error';
            this.$refs.message_dialog.show();
        }
   },
   computed: {
        user_name() {
            return this.$store.state.distributor.auth.distributor_user_name;
        }
    }
}
</script>

<style>
.container {
    background: #FFF;
    padding-top: 1em;
    padding-bottom: 1em;
}
</style>
